export default __webpack_public_path__ + "static/media/circled-pause-icon.89f10f0d.svg";